module.exports = {"530821101":"宁洱镇","530821102":"磨黑镇","530821103":"德化镇","530821104":"同心镇","530821105":"勐先镇","530821106":"梅子镇","530821201":"德安乡","530821205":"普义乡","530821206":"黎明乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530821.json
// module id = 2597
// module chunks = 0